<div class="sameta-fe-candidate-card-header">
  @if(title){
  <span class="card-title">{{ title }}</span>
  }
</div>
